module.exports = __webpack_public_path__ + "img/logo-w.84a28c7.svg";